import baseTheme from '../baseTheme';
var MuiTabs = {
    root: {
        borderBottom: "1px solid " + baseTheme.palette.grey[300],
    },
    vertical: {
        borderBottom: 'none',
        borderRight: "1px solid " + baseTheme.palette.grey[300],
    },
    flexContainerVertical: {
        '.MuiTab-root': {
            alignItems: 'flex-end',
        },
    },
};
export default MuiTabs;
//# sourceMappingURL=MuiTabs.js.map